import styled from 'styled-components';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Clickable from 'src/app/atoms/Clickable/Clickable';
import { cssVar } from 'src/app/styles/helper';

interface ProMegaMenuContainerProps {
  isOpen: boolean;
  maxHeight: number;
}

export const ProMegaMenuSideContainer = styled.div<ProMegaMenuContainerProps>`
  position: relative;
  overflow: hidden;
  transition:
    max-height 0.3s ease-in-out,
    opacity 0.3s ease-in-out;
  max-height: ${({ isOpen, maxHeight }) => (isOpen ? maxHeight : 0)}px;
`;

export const ProMegaMenuStack = styled(Stack)`
  &:hover {
    background: ${cssVar('bg-primary-hover')};
  }

  & > svg {
    flex: 0 0 20px;
  }

  .feature-content {
    flex: 1 1 fit-content;
  }
`;

export const FeaturesClickable = styled(Clickable)``;
